import { FC } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import { imageData } from './data'

import styles from './trial-payments.module.scss'

//altView - для контейнера 730px , который встречается на страницах курсов
const TrialPayments: FC<{ altView?: boolean }> = ({ altView }) => {
  return (
    <div
      className={clsx(styles.wrapper, {
        [styles.altView]: altView,
      })}
    >
      <div className={styles.block1}>
        <Image {...imageData.split}></Image>
        <div>
          <p className={styles.block1Title}>
            <span>Рассрочка</span> через Яндекс Сплит
          </p>
          <p className={styles.block1Sub}>
            Учитесь сейчас - платите потом. <br />
            Выбирайте удобный платеж на 2, 4 или 6 месяцев
          </p>
        </div>
      </div>
      <div className={styles.block3}>
        <p className={styles.block3Title}>
          За счет
          <br /> работодателя
        </p>
        <p className={styles.block3Sub}>Мы заключаем договор с работодателем, вы - учитесь</p>
      </div>
    </div>
  )
}

export default TrialPayments
